import { Card, HStack, Skeleton, VStack } from '@chakra-ui/react'

export default function SkeletonCard() {
  return (
    <Card.Root>
      <Card.Body>
        <VStack align="stretch" gap="3">
          <HStack justify="space-between" align="start" gap="3">
            <Skeleton height="18px" width="70%" />
            <Skeleton height="18px" width="48px" />
          </HStack>

          <VStack align="stretch" gap="2">
            <Skeleton height="14px" width="92%" />
            <Skeleton height="14px" width="78%" />
          </VStack>

          <HStack justify="space-between" align="center" mt="1">
            <Skeleton height="14px" width="96px" />
            <HStack gap="2">
              <Skeleton height="14px" width="14px" />
              <Skeleton height="14px" width="20px" />
            </HStack>
          </HStack>
        </VStack>
      </Card.Body>
    </Card.Root>
  )
}
